module.exports = __webpack_public_path__ + "img/bioBg9526da1.9526da14.png";